import { render, staticRenderFns } from "./BookAssesment.vue?vue&type=template&id=e12de4ca"
import script from "./BookAssesment.vue?vue&type=script&lang=js"
export * from "./BookAssesment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports